import React from 'react';

/**
 * Fil d'étapes : les étapes déjà franchies restent cliquables.
 * Sur mobile, seuls les numéros sont affichés — les libellés déborderaient ;
 * l'étape courante est nommée par l'en-tête du parcours.
 */
const StepIndicator = ({ steps, currentIndex, maxReachedIndex, onSelect }) => (
  <ol className="flex w-full items-center justify-between gap-1 sm:justify-start sm:gap-4">
    {steps.map((step, i) => {
      const done = i < currentIndex;
      const active = i === currentIndex;
      const reachable = i <= maxReachedIndex;
      return (
        <li key={step.id} className="flex min-w-0 items-center gap-2">
          <button
            type="button"
            disabled={!reachable}
            onClick={() => reachable && onSelect(i)}
            aria-label={step.label}
            aria-current={active ? 'step' : undefined}
            className={`flex h-8 w-8 shrink-0 items-center justify-center rounded-full text-xs font-semibold transition-colors ${
              active
                ? 'bg-accent text-white'
                : done
                  ? 'bg-accent/15 text-accent'
                  : 'bg-muted text-muted-foreground'
            } ${reachable ? 'cursor-pointer' : 'cursor-not-allowed'}`}
          >
            {i + 1}
          </button>
          <span
            className={`hidden truncate text-sm sm:inline ${
              active ? 'font-semibold text-foreground' : 'text-muted-foreground'
            }`}
          >
            {step.label}
          </span>
          {i < steps.length - 1 && (
            <span className="h-px w-3 shrink bg-border sm:w-8 sm:shrink-0" aria-hidden="true" />
          )}
        </li>
      );
    })}
  </ol>
);

export default StepIndicator;
